import React from 'react';
import { useJobsitePulse } from 'containers/jobsite/tabs/jobsitePulse/components/JobsitePulseProvider';
import {
  DroneCameraListItem,
  useDroneCamerasList,
  useDroneDeploy,
} from 'containers/jobsite/tabs/jobsitePulse/components/drones';
import { VideoFrame, VideoLabel, VideoThumbnail } from './video';
import { styles } from './styles';

export function CamerasList(): React.ReactElement {
  const { cameras, loading: stateLoading } = useJobsitePulse();
  const loading = stateLoading?.pulseVideos;
  const droneCameras = useDroneCamerasList();
  const { selectCamera, selectedCamera } = useDroneDeploy()!;

  if (!cameras?.length) {
    if (loading) {
      return (
        <p className="odin-text-md odin-text-slate-500">Loading cameras...</p>
      );
    }
    return (
      <p className="odin-text-md odin-text-slate-500">No cameras available</p>
    );
  }

  return (
    <div className={styles.camerasList}>
      {cameras.map((cam) => (
        <VideoFrame
          key={`camera-${cam.id}`}
          onClickVideo={() => selectCamera(cam.id)}
          className={styles.camerasListItem}
        >
          <VideoLabel
            text={cam.name}
            isSelected={selectedCamera?.id === cam.id}
          />
          <VideoThumbnail fitHeight url={cam.currentThumbnailUrl} />
        </VideoFrame>
      ))}
      {droneCameras.map((cam) => (
        <DroneCameraListItem
          key={`drone-${cam.id}`}
          cam={cam}
          isSelected={selectedCamera?.id === cam.id}
          onSelect={() => selectCamera(cam.id)}
          className={styles.camerasListItem}
        />
      ))}
    </div>
  );
}
